import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
    const onLogout = () => setUser(false);
    window.addEventListener("auth:logout", onLogout);
    return () => window.removeEventListener("auth:logout", onLogout);
  }, []);

  const login = useCallback(async (identifier, password) => {
    const r = await api.post("/auth/login", { identifier, password });
    setUser(r.data);
  }, []);

  const logout = useCallback(async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  }, []);

  const can = useCallback((p) => !!user?.perms?.includes(p), [user]);

  return <AuthCtx.Provider value={{ user, login, logout, can, isAdmin: user?.role === "admin" }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
